import customAxios from "./customAxios";

export const getReimbursementLineItems = (baseUrl, queryParams = {}) => {
  const path = `${baseUrl}/reimbursement_line_items`;
  return customAxios.get(path, { params: queryParams })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const getReimbursementLineItemsDashboard = (baseUrl, queryParams = {}) => {
  const path = `${baseUrl}/reimbursement_line_items/dashboard`;
  return customAxios.get(path, { params: queryParams })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const getReimbursementsPendingCount = baseUrl => {
  const path = `${baseUrl}/reimbursement_line_items/pending_count`;
  return customAxios.get(path)
    .then(({ data, status }) => ({ response: data.json, status }))
    .catch(error => ({ error }));
};

export const getReimbursementsUnpaidCount = baseUrl => {
  const path = `${baseUrl}/reimbursement_line_items/unpaid_count`;
  return customAxios.get(path)
    .then(({ data, status }) => ({ response: data.json, status }))
    .catch(error => ({ error }));
};

export const getMyDeclinedReimbursementsCount = baseUrl => {
  const path = `${baseUrl}/reimbursement_line_items/my_declined_count`;
  return customAxios.get(path)
    .then(({ data, status }) => ({ response: data.json, status }))
    .catch(error => ({ error }));
};

export const getReimbursementLineItemAuditsDashboard = baseUrl => {
  const path = `${baseUrl}/reimbursement_line_items/dashboard_audits`;
  return customAxios.get(path)
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const createReimbursementLineItem = (baseUrl, formData) => {
  const path = `${baseUrl}/reimbursement_line_items`;
  return customAxios.post(path, formData)
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const updateReimbursementLineItem = (baseUrl, id, formData) => {
  const path = `${baseUrl}/reimbursement_line_items/${id}`;
  return customAxios.patch(path, formData)
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const deleteReimbursementLineItem = (baseUrl, id) => {
  const path = `${baseUrl}/reimbursement_line_items/${id}`;
  return customAxios.delete(path)
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const approveReimbursementLineItem = (baseUrl, id) => {
  const path = `${baseUrl}/reimbursement_line_items/${id}/approve`;
  return customAxios.post(path)
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const declineReimbursementLineItem = (baseUrl, id, reason) => {
  const path = `${baseUrl}/reimbursement_line_items/${id}/decline`;
  return customAxios.post(path, { reason })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const setReimbursementLineItemPaid = (baseUrl, id, paid) => {
  const path = `${baseUrl}/reimbursement_line_items/${id}/set_paid`;
  return customAxios.post(path, { paid })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export async function openDashboardSubmitterReimbursementPdf(baseUrl, queryParams = {}) {
  const path = `${baseUrl}/reimbursement_line_items/dashboard_submitter_pdf`;
  const qs = new URLSearchParams();
  ["user_id", "occurred_on_from", "occurred_on_to", "paid_filter", "status_filter", "line_item_ids"].forEach(key => {
    const v = queryParams[key];
    if (v !== undefined && v !== null && v !== "") qs.append(key, String(v));
  });

  const token = typeof gon !== "undefined" && gon.auth_token ? gon.auth_token : "";

  const csrfMeta = typeof document !== "undefined" ? document.querySelector('meta[name="csrf-token"]') : null;
  const csrf = csrfMeta?.getAttribute("content");

  const res = await fetch(`${path}?${qs.toString()}`, {
    method: "GET",
    headers: {
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
      ...(token ? { Authorization: token } : {}),
      Accept: "application/json",
    },
    credentials: "same-origin",
  });

  if (!res.ok) {
    const raw = await res.text();
    let detail = raw?.slice(0, 300) || res.statusText || `Request failed (${res.status})`;
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) detail = parsed.join(" ");
      else if (parsed && typeof parsed === "object" && parsed.errors) {
        detail = Array.isArray(parsed.errors) ? parsed.errors.join(" ") : String(parsed.errors);
      }
    } catch (_e) {}
    return { error: detail };
  }

  const buf = await res.arrayBuffer();
  const mime = res.headers.get("Content-Type")?.split(";")[0]?.trim() || "";
  const blob = new Blob([buf], {
    type: mime.toLowerCase().includes("pdf") ? "application/pdf" : mime || "application/pdf",
  });
  const blobUrl = URL.createObjectURL(blob);
  const win = window.open(blobUrl, "_blank", "noopener,noreferrer");
  if (!win) {
    URL.revokeObjectURL(blobUrl);
    return { error: "Pop-up blocked. Allow pop-ups for this site to view the PDF." };
  }
  window.setTimeout(() => URL.revokeObjectURL(blobUrl), 120_000);
  return { ok: true };
}
